export default function(el, binding) {
  if (process.env.NODE_ENV === 'test')
    el.setAttribute('data-test-id', binding.value.id)
}
